import React from 'react'

export default function useTimeoutIds(delay: number): [React.Dispatch<string>, readonly string[]] {
  const [ids, setIds] = React.useState<string[]>([])

  const addId = (id: string) => {
    setIds(state => state.concat(id))
    setTimeout(() => {
      setIds(state => state.filter(it => it !== id))
    }, delay)
  }

  return [addId, ids]

}
